import type { MonthlyBudgetSetRequest, MonthlyBudgetStatus } from '@ayub/shared'
import { apiGet, apiPut } from '@/lib/api'

/** `GET /api/budget` — joriy oy (yoki berilgan year/month) byudjet holati. */
export function fetchBudgetStatus(params?: {
  year: number
  month: number
}): Promise<MonthlyBudgetStatus> {
  const qs = params !== undefined ? `?year=${params.year}&month=${params.month}` : ''
  return apiGet<MonthlyBudgetStatus>(`/budget${qs}`)
}

/** `PUT /api/budget` — byudjetni o'rnatish/tahrirlash (faqat super admin). */
export function setBudget(body: MonthlyBudgetSetRequest): Promise<MonthlyBudgetStatus> {
  return apiPut<MonthlyBudgetStatus>('/budget', body)
}
